<div class="sidebar">
  <p-tabMenu [model]="items" [activeItem]="items[0]"></p-tabMenu>
  <rb-navigation [hidden]="activeItem !== items[0]" [form]="form" [eutrDocument]="eutrDocument"></rb-navigation>
  <rb-file-upload-pane [hidden]="activeItem !== items[1]" [form]="form"
                       [eutrDocument]="eutrDocument"></rb-file-upload-pane>
</div>
